<template>
  <div>
    <div class="page">
        <header>
            <div class="icon"></div>
            <p>疯播直播</p>
        </header>
        <div class="down">
            <a id="download" href="javascript: void(0)" @click="getDownload"></a>
        </div>
        <div class="one">
            <p class="text">如果安装后打不开？快看这里</p>
            <div class="box">
                <p>1. 下载安装完成后，打开手机【设置】，然后点击【通用】</p>
                <img src="@/images/download/one.png" alt="">
            </div>
        </div>
        <div class="two">
            <div class="box">
                <p>2. 进入到【设置管理】</p>
                <img src="@/images/download//two.png" alt="">
            </div>
        </div>
        <div class="three">
            <div class="box">
                <p>3. 找到【jinhua 9158...】, 并点击进入</p>
                <img src="@/images/download//three.png" alt="">
            </div>
        </div>
        <div class="four">
            <div class="box">
                <p>4.找到【jinhua 9158...】即可完成。<br>
                    APP就可以使用啦！</p>
                <img src="@/images/download//four.png" alt="">
            </div>
        </div>
        <img src="@/images/download//tip.png" class="opaTip com" v-if="isShow">
    </div>
    <div class="opa com" v-if="isShow" ref="opa" :style="'height: ' + height + 'px;'"></div>
  </div>
</template>

<script>
import '@/js/hotcss.js'
export default {
  name: 'DownLoad',
  data () {
    return {
      isShow: false,
      height: 0
    }
  },
  methods: {
    getDownload () {
      var ua = navigator.userAgent.toLowerCase();
      
    //   console.log(height)
      if (ua.match(/MicroMessenger/i) == "micromessenger") {//在微信中打开
        this.height = document.body.scrollHeight
        this.isShow = true
      } else {
        window.location.href='itms-services://?action=download-manifest&url=https://dl.fengbolive.com/ios/manifest_10051.plist';
      }
    }
  }
}
</script>
<style>
*{
    margin: 0;
    padding: 0
}
*{ -webkit-tap-highlight-color:rgba(0,0,0,0); }

html{
    font-size:62.5%;
}
body {
    width:100%;
    background: #413280;
    font-family: 'PingFang', '微软雅黑', 'helvetica neue',tahoma,'hiragino sans gb',stheiti,'wenquanyi micro hei',\5FAE\8F6F\96C5\9ED1,\5B8B\4F53,sans-serif;
}
li {
    list-style-type: none;
}
a{
    text-decoration: none;
}
.page {
    min-width: 6.826667rem;
    text-align: center;
    margin: 0px auto;
    font-size: 0.22rem;
    overflow: hidden;
}
.page header{
    height: 22.72rem;
    background: url('~@/images/download/logo.jpg') no-repeat center;
    background-size: 100%;
    overflow: hidden;
}
.page header .icon{
    width: 2.133333rem;
    height: 2.133333rem;
    background: url('~@/images/download/icon.png') no-repeat center;
    background-size: 100%;
    margin: 19.584rem auto 0;
}
.page header p{
    line-height: 0.981333rem;
    color: #fff;
    font-size: 0.469333rem;
}
.page .down{
    height: 3.690667rem;
    overflow: hidden;
}
.page .down a#download{
    width: 8.042667rem;
    height: 1.856rem;
    margin: 0.896rem auto 0;
    background: url('~@/images/download/btn.png') no-repeat center;
    background-size: 100%;
    outline: none;
    border: none;
    display: block;
}
.page .one{
    width: 14.506667rem;
    height: 12.544rem;
    overflow: hidden;
    margin: 0 auto;
}
.page .one p.text{
    text-align: left;
    line-height: 1.834667rem;
    color: #fff;
    font-size: 0.725333rem;
}
.page .one div.box{
    width: 14.506667rem;
    height: 10.112rem;
    margin: 0.341333rem auto 0;
    overflow: hidden;
    background: url('~@/images/download/oneBox.png') no-repeat center;
    background-size: 100%;
}
.page .one div.box p, .page .two div.box p, .page .three div.box p, .page .four div.box p{
    line-height: 0.810667rem;
    color: #fff;
    font-size: 0.554667rem;
    text-align: left;
    margin-top: 0.554667rem;
    padding-left: 1.066667rem;
    text-indent: -0.64rem;
}
.page .one div.box img{
    widows: 7.317333rem;
    height: 7.296rem;
    display: block;
    margin: 0.213333rem auto 0;
}
.page .two {
    height: 12.288rem;
    overflow: hidden;
    width: 14.506667rem;
    margin: 0 auto;
}
.page .two div.box{
    width: 14.506667rem;
    height: 11.349333rem;
    margin: 0.384rem auto 0;
    overflow: hidden;
    background: url('~@/images/download/twoBox.png') no-repeat center;
    background-size: 100%;
}
.page .two div.box img{
    width: 7.317333rem;
    height: 9.194667rem;
    display: block;
    margin: 0.469333rem auto 0;
}
.page .three{
    width: 14.506667rem;
    height: 11.050667rem;
    overflow: hidden;
    margin: 0 auto;
}
.page .three div.box{
    height: 9.92rem;
    width: 14.506667rem;
    margin: 0.597333rem auto 0;
    overflow: hidden;
    background: url('~@/images/download/threeBox.png') no-repeat center;
    background-size: 100%;
}
.page .three div.box img{
    width: 7.317333rem;
    height: 7.658667rem;
    margin: 0.597333rem auto 0;
    display: block;
}
.page .four{
    height: 13.013333rem;
    overflow: hidden;
    margin: 0 auto;
    width: 14.506667rem;
}
.page .four div.box{
    margin: 0.597333rem auto 0;
    width: 14.506667rem;
    height: 10.752rem;
    overflow: hidden;
    background: url('~@/images/download/fourBox.png') no-repeat center;
    background-size: 100%;
}
.page .four div.box img{
    width: 7.317333rem;
    height: 8.362667rem;
    margin: 0 auto;
    display: block;
}
  .opa{z-index: 2; width: 100%; opacity: 0.7; position: absolute; right: 0px; top: 0px; height: 810px; background: rgb(0, 0, 0);}
  .opaTip{width:16rem;height:5.248rem; position: absolute; right: 0;top:0.1rem;z-index:33}
</style>
